interface IInertHtmlProps {
	inert?: string;
}

export function getInertProps(isInert: boolean): IInertHtmlProps {
	return isInert ? { inert: '' } : {};
}
